(function ($) {
	function getImage(hit, html, components, trackSearchAttribution) {
		const hitImage = algoliaShopify.helpers.renderImage(hit, 500);
		return html`
			<div
				class="ais-product__img algolia-quick-view"
				data-handle="${hit.handle}"
			>
				<img
					src="${hitImage.src}"
					srcset="${hitImage.srcset}"
					sizes="${hitImage.sizes}"
					alt="${hit.title} - ${hit.variant_title}"
				/>
			</div>
		`;
	}

	function getTitle(hit, html, components, trackSearchAttribution) {
		return html`
			<h2 class="ais-product__title">
				<a href="${hit.url}" class="ais-product__link">
					${html`${components.Highlight({
						attribute: "title",
						hit,
					})}`}
					${algoliaShopify.helpers.variantTitleAddition(
						hit,
						hit._distinct,
					)}
				</a>
			</h2>
		`;
	}

	function getCurrencySymbol() {
		return algoliaShopify.shop.currency_symbol || "$";
	}

	function getPrice(hit, html, components, trackSearchAttribution) {
		const shopifyCurrency =
			algoliaShopify.shopify.market.multicurrency_default_format
				.split(":")[1]
				.replace("{{amount}}", "");
		var value = algoliaShopify.helpers
			.displayPrice(hit, hit._distinct)
			.replace(shopifyCurrency, "");
		return html`<div class="is-product__info__bottom__item">
			<div class="title">Price/pc.</div>
			<div class="value">${value}<sup>${shopifyCurrency}</sup></div>
		</div>`;
	}

	function getOutOfStockLabel(hit, html) {
		var stock = hit.inventory_quantity;
		var isOutOfStock = stock <= 0;
		var outOfStock = !isOutOfStock
			? ""
			: html`<span class="out-of-stock-label"
					>${algoliaShopify.translations.outOfStock}</span
			  >`;
		return outOfStock;
	}

	function getWeight(hit, html, components, trackSearchAttribution) {
		var value = hit.weight ? hit.weight.replace("GRAMS", "") : 0;
		return html`<div class="is-product__info__bottom__item">
			<div class="title">Weight</div>
			<div class="value">
				<span class="weight-value">${value ? value : "N/A"}</span
				><sup>g</sup>
			</div>
		</div>`;
	}

	function getQuantityInput(hit, html, components, trackSearchAttribution) {
		const step = collectionHandle === "all-yarns" ? 10 : 1;
		let maxQuantity = hit.inventory_quantity;
		let rest = maxQuantity % step;
		return html`
			<div class="is-product__info__bottom__item product-quantity">
				<div class="title">qty.</div>
				<div class="value">
					${!hit._distinct &&
					html`
						<input
							type="number"
							id="quantity-${hit.objectID}"
							name="quantity"
							value="0"
							min="10"
							max="${maxQuantity - rest}"
							step="${step}"
							class="qty-input trigger-add-to-cart"
							data-variant-id="${hit.objectID}"
						/>
					`}
					<span class="loading-icon"></span>
				</div>
			</div>
		`;
	}

	function getExtenalLink(hit, html) {
		const externalLink = hit?.meta?.custom?.external_link;
		if (!externalLink) return "";

		return html`
			<a
				href="${externalLink}"
				style="display:block;text-align:center"
				class="ais-product__info__bottom"
				>Read More</a
			>
		`;
	}

	function getActions(hit, html, components, trackSearchAttribution) {
		return html`<div class="is-product__info__bottom__item">
			<div class="title">Action</div>
			<div class="value">
				${!hit._distinct &&
				html`
					<form
						id="algolia-add-to-cart-${hit.objectID}"
						style="display: none;"
						action="/cart/add"
						method="post"
						enctype="multipart/form-data"
					>
						<input
							type="hidden"
							name="id"
							value="${hit.objectID}"
						/>
					</form>
					<p class="ais-hit--cart">
						${hit.can_order
							? html`
									<button
										class="ais-hit--cart-button"
										data-form-id="algolia-add-to-cart-${hit.objectID}"
									>
										${algoliaShopify.translations.addToCart}
									</button>
							  `
							: html`
									<button
										class="ais-hit--cart-button ais-hit--cart-button__disabled"
									>
										${algoliaShopify.translations
											.outOfStock}
									</button>
							  `}
					</p>
				`}
			</div>
		</div>`;
	}

	function getProductByHandle(handle) {
		return fetch(`/products/${handle}.js`)
			.then((response) => response.json())
			.then((product) => {
				return product;
			})
			.catch((error) => {
				console.error("Error fetching product data:", error);
				return null;
			});
	}

	document.addEventListener("algolia.hooks.initialize", function () {
		algoliaShopify.hooks.registerHook(
			"beforeInstantSearchProductTemplate",
			async function (
				_defaultTemplate,
				hit,
				html,
				components,
				trackSearchAttribution,
			) {
				var handle = hit.handle;
				
				var anchor =
					collectionHandle != "all-patterns"
						? `<a href="/products/${hit.handle}" class="nm-product-link" data-product-handle="${hit.handle}"></a>`
						: "";
				/** find out of stock */
				var outOfStock = getOutOfStockLabel(hit, html);
				var externalLink = getExtenalLink(hit, html);
				var form = html`
					${getPrice(hit, html, components, trackSearchAttribution)}
					${getWeight(hit, html, components, trackSearchAttribution)}
					${getQuantityInput(
						hit,
						html,
						components,
						trackSearchAttribution,
					)}
				`;
				return html`
					<div
						class="ais-product "
						data-algolia-index="${hit.index}"
						data-algolia-position="${hit.productPosition}"
						data-algolia-queryid="${hit.queryID}"
						data-algolia-objectid="${hit.objectID}"
						data-handle="${hit.handle}"
						data-variant-id="${hit.objectID}"
						data-distinct="${hit._distinct}"
						data-product-id="${hit.id}"
					>
						${getImage(
							hit,
							html,
							components,
							trackSearchAttribution,
						)}
						<div class="ais-product__info">
							${getTitle(
								hit,
								html,
								components,
								trackSearchAttribution,
							)}
							${!!externalLink ? externalLink : form}
						</div>
					</div>
					${anchor} ${outOfStock}
				`;
			},
		);

		algoliaShopify.hooks.registerHook(
			"afterISStartRemoveDefaultWidget",
			function (defaultWidgets) {
				const hitsWidget = defaultWidgets.find(
					(widget) => widget.$$type === "ais.hits",
				);

				const paginationWidget = defaultWidgets.find(
					(widget) => widget.$$type === "ais.pagination",
				);

				return [hitsWidget, paginationWidget];
			},
		);

		const { infiniteHits } = window.instantsearch.widgets;
		let triggerLoadFinishTimer = null;
		function triggerLoadFinish(){
			clearTimeout(triggerLoadFinishTimer)
			triggerLoadFinishTimer = setTimeout(() => {
				const customEvent = new CustomEvent('loadDataFromAlgoliaFinish', {
					detail: {},
					bubbles: true // Custom events can also bubble
				});
				document.dispatchEvent(customEvent)
			}, 500)
		}

		algoliaShopify.hooks.registerHook(
			"beforeISStartAddWidgetArray",
			function () {
				const infiniteHitsWidget = infiniteHits({
					container: document.querySelector(".ais-hits-container"),
					showPrevious: false,
					showMore: false,
					disabledLoadMore: true,
					templates: {
						item: (
							hit,
							{ html, components, trackSearchAttribution },
						) => {
							var anchor =
								collectionHandle != "all-patterns"
									? html`<a
											href="/products/${hit.handle}"
											class="nm-product-link"
											data-product-handle="${hit.handle}"
									  ></a>`
									: html`<a class="nm-product-link"></a>`;
							var outOfStock =
								collectionHandle != "all-patterns"
									? getOutOfStockLabel(hit, html)
									: "";
							getProductByHandle(hit.handle).then((product) => {
								var variant = product.variants.find(
									(v) => v.id === parseInt(hit.objectID),
								);
								jQuery(`#algolia-product-${hit.objectID}`)
									.find(".weight-value")
									.text(variant.weight);
								if(!variant.available) {
									jQuery(`#algolia-product-${hit.objectID}`).find('.qty-input')
									.attr("disabled", true).prop('readonly', true)
									.css({
										"cursor" : "no-drop"
									})
								}
							});
							triggerLoadFinish();
							var externalLink = getExtenalLink(hit, html);
							var form = html`
								<div class="ais-product__info__bottom">
									${getPrice(
										hit,
										html,
										components,
										trackSearchAttribution,
									)}
									${getWeight(
										hit,
										html,
										components,
										trackSearchAttribution,
									)}
									${getQuantityInput(
										hit,
										html,
										components,
										trackSearchAttribution,
									)}
								</div>
							`;

							return html`
								<div
									id="algolia-product-${hit.objectID}"
									class="ais-product "
									data-algolia-index="${hit.index}"
									data-algolia-position="${hit.productPosition}"
									data-algolia-queryid="${hit.queryID}"
									data-algolia-objectid="${hit.objectID}"
									data-handle="${hit.handle}"
									data-variant-id="${hit.objectID}"
									data-distinct="${hit._distinct}"
									data-product-id="${hit.id}"
								>
									${getImage(
										hit,
										html,
										components,
										trackSearchAttribution,
									)}
									<div class="ais-product__info">
										${getTitle(
											hit,
											html,
											components,
											trackSearchAttribution,
										)}
										${!!externalLink ? externalLink : form}
									</div>
								</div>
								${anchor} ${outOfStock}
							`;
						},
						empty: () => {
							return `<div class="ais-infinite-hits-empty">
								${algoliaShopify.translations.noResults}
							</div>`;
						},
					},
				});

				return [infiniteHitsWidget];
			},
		);

		algoliaShopify.hooks.registerHook(
			"beforeAutocompleteOptions",
			function (options) {
				// Change the placeholder text of the autocomplete menu
				options.placeholder = "Search Our Products";
				options.container = "#algolia-autocomplete";

				console.log("options", options);
				return options;
			},
		);
	});

	document.addEventListener("algolia.hooks.initialize", function () {
		algoliaShopify.hooks.registerHook(
			"beforeAutocompleteProductTemplate",
			function (
				_defaultTemplate,
				templateOptions,
				distinct,
				itemLink,
				trackSearchAttribution,
			) {
				// Modify default options, then return them
				const { html, item, components } = templateOptions;
				return html`
					<div
						class="ais-product "
						data-algolia-index="${item.index}"
						data-algolia-position="${item.productPosition}"
						data-algolia-queryid="${item.queryID}"
						data-algolia-objectid="${item.objectID}"
						data-handle="${item.handle}"
						data-variant-id="${item.objectID}"
						data-distinct="${item._distinct}"
						data-product-id="${item.id}"
					>
						${getImage(
							item,
							html,
							components,
							trackSearchAttribution,
						)}
						<div class="ais-product__info">
							${getTitle(
								item,
								html,
								components,
								trackSearchAttribution,
							)}
							<div class="ais-product__info__bottom">
								${getPrice(
									item,
									html,
									components,
									trackSearchAttribution,
								)}
								${getWeight(
									item,
									html,
									components,
									trackSearchAttribution,
								)}
								${getQuantityInput(
									item,
									html,
									components,
									trackSearchAttribution,
								)}
							</div>
						</div>
					</div>
				`;
			},
		);
	});

	function triggerLoadMore() {
		const loadMoreButton = jQuery(document).find(
			".ais-InfiniteHits-loadMore",
		);
		if (loadMoreButton.length) {
			loadMoreButton.trigger("click");
		}
	}

	let scrollTimer = 0;

	function triggerStickyFacets() {


		clearTimeout(scrollTimer);
		jQuery(document).find(".ais-facets").addClass("is-scrolling");
		jQuery(document).find(".ais-facets-button").addClass("is-scrolling");
		scrollTimer = setTimeout(() => {
			const wrapper = jQuery(document).find(".ais-page");

			if(!wrapper.length) return;

			const facets = jQuery(document).find(".ais-facets");
			const wrapperOffsetTop = wrapper.offset().top;
			const scrollPosition = jQuery(window).scrollTop();
			let elementTop = scrollPosition - wrapperOffsetTop;
			elementTop = elementTop < 0 ? 0 : elementTop;

			jQuery(document).find(".ais-facets").removeClass("is-scrolling");
			jQuery(document)
				.find(".ais-facets-button")
				.removeClass("is-scrolling");
			facets.css({
				transform: "translateY(" + elementTop + "px)",
			});
			jQuery(document)
				.find(".ais-facets-button")
				.css({
					transform: "translateY(" + elementTop + "px)",
				});
		}, 500);
	}

	setTimeout(() => {
		jQuery(window).on("scroll", function () {
			const scrollPosition =
				jQuery(window).scrollTop() + jQuery(window).height();
			const documentHeight = jQuery(document).height();
			const loadMoreButton = jQuery(document).find(
				".ais-InfiniteHits-loadMore",
			);

			if(!loadMoreButton.length) return;

			const isLoading = loadMoreButton.hasClass("loading");

			if (isLoading) {
				console.log("Already loading more items, skipping...");
				return;
			}

			if (
				scrollPosition >= loadMoreButton.offset().top - 100 &&
				loadMoreButton.length
			) {
				loadMoreButton.addClass("loading");
				triggerLoadMore();
				console.log("Load more triggered");
				setTimeout(() => {
					loadMoreButton.removeClass("loading");
				}, 500);
			}
		});

		jQuery(window).on("scroll", function () {
			triggerStickyFacets();
		});
	}, 2000);
	$(document).on("click", ".ais-dropdown-checkbox", function (e) {
		const isChecked = $(this).is(":checked");
		const parent = $(this).parents(".ais-facets");
		const sibling = parent.find(".ais-dropdown-checkbox").not(this);

		if (isChecked === false) {
			$(this).parent().removeClass("is-open");
		} else {
			$(this).parent().addClass("is-open");
		}

		$.each(sibling, function (index, element) {
			$(element).prop("checked", false);
			$(element).parent().removeClass("is-open");
		});
	});

	// Close facets when clicking outside
	$(document).on("click", function (e) {
		const target = $(e.target);
		if (
			!target.closest(".ais-facets").length &&
			!target.closest(".ais-facets-button").length
		) {
			$(".ais-dropdown-checkbox").prop("checked", false);
			$(".ais-dropdown-checkbox").parent().removeClass("is-open");
		}
	});

	document.addEventListener("algolia.hooks.initialize", function () {
		algoliaShopify.hooks.registerHook(
			"beforeInstantSearchOptions",
			function (options) {
				// Loop through the facet widgets.
				console.log("options.facets.widgets", options.facets);
				const widgets = options.facets.widgets.map((widget) => {
					if (widget.name !== "refinementList") {
						return widget;
					}

					// This updates all `refinementList` widgets.
					// If you only want to update specific facet(s),
					// you can target them by checking the value of `widget.params.container`.

					return {
						...widget,
						params: {
							...widget.params,
							limit: 200,
						},
					};
				});

				return {
					...options,
					facets: {
						...options.facets,
						widgets,
					},
				};
			},
		);
	});

	// Validate quantity input for Algolia products - only on blur (when user finishes typing)
})(jQuery);
